export const isStringQuery = (query?: any): query is string => {
  return query && !Array.isArray(query);
};
